import { DEFAULT_LATEST } from 'constants/dateLimits';
import { ValidateJSModel } from 'forms/shared/types';
import { setToStartOfMonth } from 'helpers/date';
import { isPVQForm } from 'helpers/form';
import { substanceDrugTypeValidator } from 'forms/sections/substance/shared/drugTypeValidator';
import { SubstanceDrugsClearanceItemModel } from '../types';

const substanceDrugsClearanceItemValidator: ValidateJSModel<SubstanceDrugsClearanceItemModel> = {
  DrugType: (value, attributes, attributeName, options) => {
    const isPVQ = isPVQForm(options?.formType);
    if (isPVQ) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  DrugTypeOther: (value, attributes, attributeName, options) => {
    const isPVQ = isPVQForm(options?.formType);
    if (isPVQ) {
      if (attributes?.DrugType?.value === 'Other') {
        return { presence: true, hasValue: true };
      }
    }
    return {};
  },
  HowManyTimes: (value, attributes, attributeName, options) => {
    const isPVQ = isPVQForm(options?.formType);
    if (isPVQ) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  Reason: (value, attributes, attributeName, options) => {
    const isPVQ = isPVQForm(options?.formType);
    if (isPVQ) {
      return { presence: true, hasValue: true };
    }
    return {};
  },
  Description: (value, attributes, attributeName, options) => {
    const isPVQ = isPVQForm(options?.formType);
    if (isPVQ) {
      return {};
    }
    return { presence: true, hasValue: true };
  },
  InvolvementDates: (value, attributes, attributeName, options) => ({
    presence: true,
    daterange: {
      earliest: setToStartOfMonth(options?.applicantBirthdate),
      latest: DEFAULT_LATEST
    },
  }),
  EstimatedUse: (value, attributes, attributeName, options) => {
    const isPVQ = isPVQForm(options?.formType);
    if (isPVQ) {
      return {};
    }
    return { presence: true, hasValue: true };
  },
  Comments: () => ({}),
};

export default substanceDrugsClearanceItemValidator;
